<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">N°</th>
            <th class="text-left">Fecha</th>
         
            <th class="text-left">Amortización</th>
            <th class="text-left">Intereses</th>
            <th class="text-left">IVA Intereses</th>
            <th class="text-left">Cuota Total</th>
            <th class="text-left">Fecha Prórroga</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="15" class="text-center loadingOk" v-if="loading" >Cargando...</td>

            <td
            color:
              colspan="15"
              class="text-center loadingFail"
              v-if="data.length < 1 && !loading"
            >
              No hay resultados
            </td>
          </tr>

          <tr
            v-show="data.length > 0"
            v-for="(item, index) in data"
            :key="index"
             :class="{ 'fila-prorroga': item.fechamodificacion }"
          >
            <td>{{ item.cuota }}</td>
            <td>{{ item.fecha }}</td>
           
            <td>
              ${{ formatter.format(parseFloat(item.capital || 0).toFixed(2)) }}
            </td>
            <td>
              ${{ formatter.format(parseFloat(item.interes  || 0).toFixed(2)) }}
            </td>
            <td>
              ${{ formatter.format(parseFloat(item.ImpuestoInteres || 0).toFixed(2)) }}
            </td>
          
            <td>
              ${{ formatter.format(parseFloat(item.MontoCuota || 0).toFixed(2)) }}
            </td>
            <td :class="{ 'light-text-red': item.fechamodificacion }">
              {{ formatDate(item.fechamodificacion) }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-container>
      <v-row>
        <v-col md="4" offset-md="8">
          <v-btn
            v-if="data || datos"
            color="black"
            text
            @click="exportPDF('0')"
          >
            Imprimir
          </v-btn>
          <v-btn v-if="data || datos" color="blue" text @click="exportPDF('1')">
            Descargar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { API_URL } from '@/common/config';
import logo from '@/common/logo';
import axios from 'axios';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';

export default {
  props: ['cliente', 'solicitud_id', 'operatoria'],
  name: 'CuadroMarchaProrrogados',
  data: () => ({
    data: [],
    token: localStorage.getItem('token'),
    tasa: '',
    monto: '',
    pagos: '',
    cuotas: '',
    periodo: '',
    fecha: '',
    formatter: new Intl.NumberFormat('es-AR', {
      maximumFractionDigits: 2,
    }),
    loading: false,
  }),
  methods: {
    formatDate(date) {
      // Verificar si la fecha es válida
      return moment(date).isValid() ? moment(date).format('DD/MM/YYYY') : '';
    },


    exportPDF(tipo) {
  let height = 66;
  if (this.data.length < 1) {
    return;
  }
  const doc = new JsPDF();
  const columns = [
    { title: 'Cuota', dataKey: 'Cuota' },
    { title: 'Fecha', dataKey: 'Fecha' },
    { title: 'Amortización', dataKey: 'Amortizacion' },
    { title: 'Intereses', dataKey: 'Interes' },
    { title: 'IVA Intereses', dataKey: 'ImpuestoInteres' },
    { title: 'Cuota Total', dataKey: 'MontoCuota' },
    { title: 'Fecha Prórroga', dataKey: 'fecha_Prorroga' }, // Cambiado a fecha_Prorroga para coincidir con el objeto result
  ];
  const data = JSON.parse(JSON.stringify(this.data));
  const result = [];

  data.map((key) => {
    result.push({
      Cuota: parseInt(key.cuota, 10),
      Amortizacion: this.formatter.format(parseFloat(key.Amortizacion || 0).toFixed(2)),
      MontoCuota: this.formatter.format(parseFloat(key.MontoCuota || 0).toFixed(2)), // Corregido a MontoCuota
      Fecha: key.fecha,
      ImpuestoInteres: this.formatter.format(parseFloat(key.ImpuestoInteres || 0).toFixed(2)), // Corregido a ImpuestoInteres
      Interes: this.formatter.format(parseFloat(key.Interes || 0).toFixed(2)), // Corregido a Interes
      fecha_Prorroga: this.formatDate(key.fechamodificacion), // Asegúrate de que esta función formatea correctamente
    });
  });

  const apellido = this.cliente.razonSocial ? this.cliente.razonSocial 
    : `${this.cliente.nombre} ${this.cliente.apellido}`;
  const imgData = logo;
  doc.addImage(imgData, 'PNG', 10, 5, 48, 20);
  doc.line(15, 23, 200, 23, 'FD');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.text('Prórroga del Crédito', 15, 30);
  doc.text(this.fecha, 150, 30);
  doc.text(`Nombre: ${apellido}`, 15, 37);
  doc.line(15, 39, 200, 39, 'FD');
  doc.setFontSize(15);

  // Agregar estilos condicionales directamente en autoTable
  doc.autoTable(columns, result, {
    startY: height,
    margin: { horizontal: 7 },
    styles: { cellWidth: 'wrap', halign: 'center' },
    columnStyles: { text: { cellWidth: 'auto' } },
    didParseCell: (data) => {
      if (data.row.raw.fecha_Prorroga) {
        data.cell.styles.fillColor = [178, 186, 187 ]; // Color gris claro
      }
    },
  });

  if (tipo === '0') {
    window.open(doc.output('bloburl'), '_blank');
  } else {
    doc.save(`Desarrollo del Crédito ${apellido}.pdf`);
  }
},

    async cargarDesarrolloTrilay() {
      // Validar que solicitud_id esté definido y sea válido
      if (!this.solicitud_id || this.solicitud_id <= 0) {
        console.error('legajo no es válido');
        return;
      }
      this.loading = true;
      try {
        // Construir la URL con el parámetro legajo
        const url = `${API_URL}api/trilay/desarrolloCreditoProrrogado/${this.solicitud_id}`;

        // Configurar los headers
        const header = {
          headers: {
            'Content-Type': 'application/json',
            token: localStorage.getItem('token'),
          },
        };

        // Realizar la solicitud GET al endpoint
        const response = await axios.get(url, header);

        // Verificar el estado de la respuesta
        if (response.data.status === 'success') {
          this.data = response.data.cuotasCredito; // Asignar los datos de las cuotas
        } else {
          console.error(
            'Error en la respuesta del servidor:',
            response.data.message
          );
        }
      } catch (error) {
        console.error('Error al cargar el desarrollo del crédito:', error);
      } finally {
        this.loading = false; // Desactivar el indicador de carga
      }
    },
  },
  mounted() {
    // Llamar al método cuando el componente se monta
    this.cargarDesarrolloTrilay();
  },
};
</script>
<style>
.cc thead {
  font-weight: 700;
}
.cc thead td {
  background-color: #f2f2f2;
  font-size: 12px !important;
}
.cc td {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  font-size: 12px !important;
  padding: 0 5px !important;
}
.loadingOk {
  background-color:  rgb(52, 192, 68) !important;
}
.loadingFail {
  background-color:rgb(216, 34, 34)!important;
} 
.light-text-red {
  color:rgb(216, 34, 34)!important;
  

}
.fila-prorroga {
  background-color: #dddbdb; /* Color gris clarito */
}
</style>
